<template>
  <div class="app-container">
    <el-card class="box-card">
    <!-- 数据操作区：按钮 -->
    <div class="operation-wrapper">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="primary" plain icon="Plus" @click="handleAdd" >新增公告</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button type="danger" plain icon="Delete" @click="handleDeleteBatch" :disabled="!multiple">批量删除</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 数据展示区：表格 -->
    <div class="table-wrapper">
      <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="公告名称" prop="name" align="center" />
        <el-table-column label="内容" prop="content" align="center" show-overflow-tooltip />
        <el-table-column label="活动开始时间" prop="beginTime" align="center" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.beginTime) }}
          </template>
        </el-table-column>
        <el-table-column label="活动结束时间" prop="endTime" align="center" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column label="图片" prop="image" align="center">
        <template #default="scope">
          <el-image
            v-if="scope.row.image"
            style="width: 50px; height: 50px"
            :src="scope.row.image"
            :preview-src-list="[scope.row.image]"
            fit="cover"
          >
            <template #error>
              <div class="image-slot">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="scope">
            <div class="operation-buttons">
              <el-button type="primary" link size="small" @click="handleUpdate(scope.row)">编辑</el-button>
              <el-button type="danger" link size="small"  @click="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 数据展示区：分页加载 -->
    <div class="pagination-wrapper">
      <el-pagination style="margin-top: 20px ;"
        v-model:current-page="queryParams.page"
        v-model:page-size="queryParams.pageSize"
        :page-sizes="[50, 100, 150]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    
  <!-- 数据编辑区：新增/修改对话框 -->
  <NoticeForm
    :title="title"
    v-model:open="dialogVisible"
    :edit-data="editingNotice"
    @refresh-list="getList"
  />
  <!-- :categoryOptions="categoryOptions" -->
    <el-drawer v-model="drawer" title="查看标准详情" direction="rtl" size="600px">
      <el-descriptions :title="noticeTitle" :column="1" border>
        <el-descriptions-item label="公告名称">{{ notice.name }}</el-descriptions-item>
        <el-descriptions-item label="公告详情">{{ notice.content }}</el-descriptions-item>
        <el-descriptions-item label="活动开始时间">{{ notice.beginTime }}</el-descriptions-item>
        <el-descriptions-item label="活动结束时间">{{ notice.endTime }}</el-descriptions-item>
        <el-descriptions-item label="图片">
          <el-image
            v-if="notice.image"
            style="width: 100px; height: 100px"
            :src="notice.image"
            :preview-src-list="[notice.image]"
            fit="cover"
          >
            <template #error>
              <div class="image-slot">暂无图片</div>
            </template>
          </el-image>
          <span v-else>暂无图片</span>
        </el-descriptions-item> 
      </el-descriptions>
    </el-drawer>
  </el-card>
  </div>
</template>

<script lang="ts" setup>
/** ------------------全局导入区-------------------- */
import { ref, reactive, toRef, onMounted, computed } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import type{   NoticeItem, RuleForm,NoticeDTO,QueryParams } from "@/types/notice";
import NoticeForm from "@/notice/NoticeForm.vue";
import { listNoticeByPage, deleteNoticeBatch,deleteNotice } from '@/notice/notice';
import dayjs from 'dayjs'

onMounted(() => {
// 挂载后加载数据
getList()
})
// 修改 formatDate 函数的类型定义
const formatDateTime = (date: string | Date | null | undefined) => {
if (!date) return '';
// 如果是 Date 对象，转换为字符串
if (date instanceof Date) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}
// 如果已经是字符串格式，直接返回
return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};
/** ------------------数据查询区——表单-------------------- */

// 查询
const query = reactive<QueryParams>({
  page: 1,
  pageSize: 50
})
const queryParams = toRef(query)


/** ------------------数据展示区——表格-------------------- */

// 数据列表
const loading = ref<boolean>(false)  // table数据加载遮罩
const total = ref<number>(0) // table数据总数
const tableData = reactive<NoticeItem[]>([]) // table数据

// 数据展示区--> 数据加载
function getList() {
loading.value = true;
try {
  listNoticeByPage({
    page: queryParams.value.page,
    pageSize: queryParams.value.pageSize
  }).then(response => {
    if (response && response.code === 1) {

      // 直接赋值，不使用 .value
      tableData.splice(0, tableData.length, ...response.data.records || []);
      total.value = response.data.total || 0;
    }
  });
} catch (error) {
  console.error('获取数据失败:', error);
  ElMessage.error('获取数据失败');
} finally {
  loading.value = false;
}
}

/** ------------------数据展示区：数据选择-------------------- */

const ids = ref<string[]>([]) // 表单勾选的id
const single = ref<boolean>(false) // 勾选1个
const multiple = computed(() => ids.value.length > 0)

// 数据展示区--> 勾选数据
function handleSelectionChange(selection: StandardDTO[]) {
ids.value = selection.map((item:StandardDTO) => item.id)
single.value = selection.length == 1
}

/** ------------------数据展示区：分页加载-------------------- */
// 分页--> 修改每页数据数（5｜10｜20｜30）
function handleSizeChange(val: number) {
queryParams.value.pageSize = val;
queryParams.value.page = 1; // 切换页大小时重置页码
getList();
}

//分页--> 修改当前页
function handleCurrentChange(val: number) {
queryParams.value.page = val;
getList();
}

/** ------------------数据编辑区——对话框+表单-------------------- */
// 表单数据
const formRef = ref<FormInstance>()

const formData = reactive<RuleForm>({
id: '',
beginTime: null,
endTime: null,
content: '',
name: '',
image: ''

})


// 对话框数据
const title = ref('') // 对话框标题


/** ------------------数据操作区——按钮-------------------- */
// 对话框和抽屉控制
const dialogVisible = ref(false)
const drawer = ref(false)
const editingNotice = ref<any>(null)

// 清空或赋值表单数据
const initForm = () => {
formRef.value?.resetFields() 
}

// 数据操作区--> 新增按钮
function handleAdd() {
title.value = '新增公告'

// 清空编辑数据
editingNotice.value = null
// 打开对话框
dialogVisible.value = true
}

// 数据操作区区--> 修改按钮
function handleUpdate(row: any) {
// 设置编辑数据
editingNotice.value = row
// 打开对话框
dialogVisible.value = true
title.value = '修改公告['+ row.id +']'

}

// 数据操作区--> 删除按钮
function handleDelete(row: any) {
const id = row.id
ElMessageBox.confirm(
  `是否确认删除编号为"${id}"的标准?`,
  '警告',
  {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }
)
.then(async () => {
  try {
    const response = await deleteNotice(id)
    if (response?.code === 1) {
      ElMessage.success('删除成功')
      getList() // 刷新列表
    } else {
      ElMessage.error(response?.msg || '删除失败')
    }
  } catch (error) {
    console.error('删除失败:', error)
    ElMessage.error('删除失败，请重试')
  }
})
.catch(() => {
  ElMessage.info('已取消删除')
})
}

// 数据操作区--> 批量删除
function handleDeleteBatch() {
if (!ids.value || ids.value.length === 0) {
  ElMessage.warning('请选择要删除的标准')
  return
}

ElMessageBox.confirm(
  `是否确认批量删除选中的${ids.value.length}条标准数据?`,
  '警告',
  {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }
)
.then(async () => {
  try {
    console.log('批量删除的ids:', ids.value.join(','))
    const response = await deleteNoticeBatch(ids.value)
    if (response?.code === 1) {
      ElMessage.success('批量删除成功')
      getList() // 刷新列表
    } else {
      ElMessage.error(response?.msg || '批量删除失败')
    }
  } catch (error) {
    console.error('批量删除失败:', error)
    ElMessage.error('批量删除失败，请重试')
  }
})
.catch(() => {
  ElMessage.info('已取消删除')
})
}

// 数据操作区-->抽屉查看数据
// const drawer = ref<boolean>(false)
const noticeTitle = ref<string>('');
// ... existing code ...
const notice = ref<NoticeDTO>({
id: '',
content: '',
name: '',
beginTime: '',
endTime: '',
image: ''
})
const refreshList = () => {
getList()  // 调用父组件的数据加载方法
}

</script>
<style scoped>
.app-container {
padding: 20px;
}

.box-card {
box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.search-wrapper {
padding: 18px 0;
margin-bottom: 10px;
background-color: #fff;
border-radius: 4px;
}

.operation-wrapper {
margin-bottom: 16px;
}

.table-wrapper {
margin-bottom: 16px;
background: #fff;
border-radius: 4px;
}

.pagination-wrapper {
padding: 15px;
text-align: right;
background: #fff;
border-radius: 4px;
}

/* 表格内图片列样式 */
.image-preview {
width: 50px;
height: 50px;
border-radius: 4px;
overflow: hidden;
}

/* 操作按钮样式 */
.operation-buttons {
display: flex;
align-items: center;
justify-content: center;
gap: 8px;
}

/* 表单项间距 */
:deep(.el-form-item) {
margin-bottom: 18px;
margin-right: 18px;
}

/* 卡片内边距 */
:deep(.el-card__body) {
padding: 20px;
}

/* 表格内容垂直居中 */
:deep(.el-table .cell) {
display: flex;
align-items: center;
justify-content: center;
}

/* 按钮组样式 */
.mb8 {
margin-bottom: 8px;
display: flex;
gap: 8px;
}

.dialog-footer {
text-align: right;
}
.image-slot {
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 100%;
background: #f5f7fa;
color: #909399;
}

/* 操作按钮样式 */
:deep(.el-button--link) {
padding: 4px 8px;
height: 28px;
font-size: 13px;
}

:deep(.el-button--link:hover) {
background-color: #f5f7fa;
border-radius: 4px;
}

/* 不同类型按钮的颜色 */
:deep(.el-button--primary.is-link) {
color: #409eff;
}

:deep(.el-button--danger.is-link) {
color: #f56c6c;
}

:deep(.el-button--info.is-link) {
color: #909399;
}

:deep(.el-button--success.is-link) {
color: #67c23a;
}

/* 表格列宽度调整 */
:deep(.el-table .operation-column) {
min-width: 280px;
}
</style>

